import type { PostConfigObject } from "app/services/fetchService";
import { DefaultFetchService } from "app/services/fetchService";

import type { OnboardingAgentRequestPayload, OnboardingAgentResponse } from "../onboardingAgent.types";

const fetchService = DefaultFetchService.getInstance();

const ONBOARDING_AGENT_API_URL = "/api/onboarding/agent";

export const onboardingAgentApiService = {
    sendMessage(
        payload: OnboardingAgentRequestPayload,
        options?: Readonly<PostConfigObject>,
    ): Promise<OnboardingAgentResponse> {
        return fetchService.post<OnboardingAgentResponse>(ONBOARDING_AGENT_API_URL, payload, options);
    },
};
